import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'cosmos-sidebar-menu-item',
  templateUrl: './sidebar-menu-item.component.html',
  styleUrls: ['./sidebar-menu-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SidebarMenuItemComponent {
  @Input()
  public header: string;

  @Input()
  public isContentVisible = false;

  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() public toggle = new EventEmitter();
}
